import { createModule } from '../../createModule';
export const createWebsiteAPI = createModule(({ http }) => {
    return {
        getInvestmentSecurity: async (params = {}) => {
            const res = await http.get('/v2/website/investment/security', { params });
            return res;
        },
        updateInvestmentSecurity: async (body) => {
            const res = await http.patch('/v2/website/investment/security', { body: body });
            return res;
        },
        addInvestmentSecurityToWebsite: async (body) => {
            const res = await http.post('/v2/website/investment/security', { body: body });
            return res;
        },
        removeInvestmentSecurityFromWebsite: async ({ isin, }) => {
            const res = await http.delete(`/v2/website/investment/security/${isin}`);
            return res;
        },
        addInvestmentScheduleToWebsite: async (body) => {
            const res = await http.post('/v2/website/investment/schedule', { body: body });
            return res;
        },
        getSecondaryMarket: async (params = {}) => {
            const res = await http.get('/v2/website/investment/secondary-market', { params });
            return res;
        },
        updateSecondaryMarket: async (body) => {
            const res = await http.patch('/v2/website/investment/secondary-market', {
                body: body,
            });
            return res;
        },
    };
});
